import { featureCollection, point } from '@turf/turf';
import type { Map } from 'mapbox-gl';

import { zoomOnFeature } from '@map';

import type { GpAssignmentMapPoint } from '../../data-access/types/gp-sampling-assignment';

export function pointsToFeatureCollection(points: GpAssignmentMapPoint[]) {
  return featureCollection(
    points.map((p) => point(p.geometry.coordinates, { id: p.id })),
  );
}

export function zoomMapToPoints(map: Map | undefined, points: GpAssignmentMapPoint[]) {
  if (!map || points.length === 0) {
    return;
  }

  zoomOnFeature({
    map,
    geojson: pointsToFeatureCollection(points),
    padding: 80,
  });
}
